module.exports = __webpack_public_path__ + "img/app_logo_inverted.c2e37961.png";